import { Box, Card, CardContent, Typography, useTheme } from '@mui/material';
import { useIntl } from 'react-intl';

const ProjectBasicsCard = ({ title, description }: { title: string; description: string }) => {
  return (
    <Card sx={{ flex: 1 }} elevation={2}>
      <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Typography variant="h6">{title}</Typography>
        <Typography variant="body1">{description}</Typography>
      </CardContent>
    </Card>
  );
};

export interface ProjectBasicsProps {
  projectName: string;
  conditionAreaName: string;
  healthSystemName: string;
}
export const ProjectBasics = ({
  projectName,
  conditionAreaName,
  healthSystemName,
}: ProjectBasicsProps) => {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  return (
    <Box>
      <Box sx={{ display: 'flex', gap: theme.spacing(6) }}>
        <ProjectBasicsCard
          description={formatMessage({
            id: 'createProjectWizard.step.reviewAndCreate.projectBasics.card.projectName',
          })}
          title={projectName ?? '--'}
        />
        <ProjectBasicsCard
          description={formatMessage({
            id: 'createProjectWizard.step.reviewAndCreate.projectBasics.card.conditionArea',
          })}
          title={conditionAreaName ?? '--'}
        />
        <ProjectBasicsCard
          description={formatMessage({
            id: 'createProjectWizard.step.reviewAndCreate.projectBasics.card.healthSystem',
          })}
          title={healthSystemName ?? '--'}
        />
      </Box>
    </Box>
  );
};
